import { type ReactNode } from 'react';

import { Outlet } from 'react-router-dom';

const EditorLayout = (): ReactNode => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default EditorLayout;
